export default __webpack_public_path__ + "static/media/bg-04.e54b5dd8.png";